import { Button } from "@/components/ui/button";
import { proxiedImage } from "@/lib/api";

const STAKES = [
  { headline: "Up to $10,000", sub: "Cash awards invested directly into their businesses" },
  { headline: "Professional Services", sub: "Legal services, websites, logos, legal entity filing, accounting and more" },
  { headline: "Marketing & Exposure", sub: "Community visibility and audience growth" },
  { headline: "Strategic Partners", sub: "Connections to financial institutions, sponsors and partners" },
  { headline: "Potential Customers", sub: "Opportunities to meet supporters and supporters' networks" },
  { headline: "Community Recognition", sub: "Credibility that strengthens their next chapter" },
  { headline: "Continued Support", sub: "Resources beyond the event to help build sustainable businesses" },
];

export default function WhatsAtStake({ externalVotingUrl, cohortImage, sectionId }) {
  return (
    <section id={sectionId} data-testid="whats-at-stake" className="bg-emerald-950 text-white py-20 sm:py-24 border-t border-b border-emerald-900">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-7 space-y-8">
            <div>
              <div className="text-[11px] uppercase tracking-[0.3em] text-amber-300 font-[Outfit] font-bold">
                What's At Stake for the Businesses?
              </div>
              <h2 className="font-[Cormorant_Garamond] text-4xl sm:text-5xl text-white mt-4 leading-[1.05]">
                They are not just pitching for a prize.
              </h2>
              <p className="font-[Outfit] text-emerald-50 mt-5 leading-relaxed text-lg max-w-2xl">
                They are pitching for the resources, relationships and visibility that could change the direction of their businesses. Through Business Showers, participating entrepreneurs may receive:
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {STAKES.map((s, i) => (
                <div key={i} data-testid={`stake-${i}`} className="bg-emerald-900 border border-emerald-800 p-5 rounded-lg">
                  <div className="font-[Cormorant_Garamond] text-2xl text-amber-300 leading-tight">{s.headline}</div>
                  <div className="font-[Outfit] text-sm text-emerald-50 mt-1.5 leading-relaxed">{s.sub}</div>
                </div>
              ))}
            </div>

            <div className="bg-amber-300 text-emerald-950 p-6 sm:p-7 rounded-lg">
              <div className="font-[Cormorant_Garamond] text-xl sm:text-2xl leading-snug">
                For many of these entrepreneurs, one connection, one resource, or one community vote could become the next step toward growth, stability and long-term success.
              </div>
              <div className="mt-3 font-[Outfit] text-sm font-semibold uppercase tracking-wider">
                Every pitch matters · Every vote matters
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 space-y-6">
            <div className="rounded-lg overflow-hidden border-2 border-amber-300 bg-white">
              {cohortImage && (
                <img src={proxiedImage(cohortImage)} alt="Meet our 2026 cohort" className="w-full h-auto block" loading="lazy" />
              )}
            </div>
            <div className="bg-rose-500 text-white p-7 rounded-lg">
              <div className="text-[10px] uppercase tracking-[0.3em] text-rose-100 font-[Outfit] font-bold">Your Vote</div>
              <div className="font-[Cormorant_Garamond] text-2xl sm:text-3xl mt-2 leading-tight">
                "We see you. We believe in what you're building. Keep going."
              </div>
              <div className="font-[Outfit] text-sm text-rose-50 mt-3 leading-relaxed">
                Support a business. Share their story. Cast your $2 vote.
              </div>
              <Button asChild data-testid="stakes-vote-btn" className="mt-5 rounded-full bg-white text-rose-600 hover:bg-emerald-50 font-[Outfit] font-semibold h-11 px-6">
                <a href={externalVotingUrl} target="_blank" rel="noreferrer">Cast Your $2 Vote</a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
